import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState({ key: 'wifi' })],
  state: {
    user: {
      username: null,
      token: null,
      isAuth: false,
    },
    /**
     * Переадресации пользователя.
     */
    redirects: null,
    /**
     * Адреса на договоре пользователя.
     */
    objects: null,
    /**
     * Шаблоны страниц приветствия.
     */
    templates: null,
    /**
     * Ваучеры, выданные пользователю.
     */
    vouchers: null,
    /**
     * Временный объект с данными при создании/редактировании
     * шаблона страницы приветствия.
     * Служит для обеспечения доступности ранее введенных данных
     * при переходах от одного шага к другому.
     */
    template: {},
    /**
     * При переходах внутри мастера создания шаблона между шагами
     * записываем в данное свойство значение, чтобы в случае если
     * пользователь покинул текущий маршрут, то после при редактировании
     * он продолжил с такого шага на котором остановился.
     */
    templateStep: 0,
    /**
     * Объекты-привязки шаблонов страниц приветствия к адресам договора.
     */
    bindings: null,
    /**
     * Позволяет управлять отображением модального окна `Новости от разработчиков`.
     */
    isShowModal: true,
  },
  actions,
  getters,
  mutations,
})



// WEBPACK FOOTER //
// ./src/store/index.js